import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import NavBar from '../../components/NavBarSearchSong';
import { Grid } from '@material-ui/core';

// Images
import Settings from '../../assets/Settings.png';

// Components
import Button from '../../components/Button';
import SearchBox from '../../components/SearchBox';
import PlaylistTable from '../../components/PlaylistTable';

import { playlistActions } from '../../actions';
import { playlistStore } from '../../store';

import { size } from 'lodash';

const UnlimitedPlaylist = () => {
  const refference = useRef(true);
  const [loading, setLoading] = useState(false);
  const LIMIT = 50;
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState({ page: 1, isLast: false });
  const [isLoading, setIsLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [rowsData, setRowsData] = useState([
    {
      id: 1,
      playlistImg: '',
      result: 1,
      date: '',
      playlist: 'Playlist',
      action: '',
    },
  ]);

  // Zustand
  const { playlists, setPlaylists } = playlistStore((state) => ({
    playlists: state.unlimitedPlaylists,
    setPlaylists: state.setUnlimitedPlaylists,
  }));

  useEffect(() => {
    if (!refference.current) {
      refference.current = false;
      return;
    }

    (async () => {
      setIsLoading(true);
      const playlistsFromBE = await playlistActions.fetchAllPlaylist({
        page: 1,
        type: 'UNLIMITED',
        limit: LIMIT,
        search: searchInput,
      });

      setPlaylists(playlistsFromBE);
      setIsLoading(false);
      setCurrentPage({ page: 1, isLast: false });
    })();
  }, [searchInput]);

  // Fetch the data from the Playlist API
  const fetchMorePlaylists = async () => {
    if (isFetchingMore || currentPage.isLast) return;
    setIsFetchingMore(true);
    const playlistsFromBE = await playlistActions.fetchAllPlaylist({
      page: currentPage.page,
      limit: LIMIT,
      search: searchInput,
      type: 'UNLIMITED',
    });

    setPlaylists([...playlists, ...playlistsFromBE]);
    setIsFetchingMore(false);
    setCurrentPage((prev) => ({
      page: prev.page + 1,
      isLast: size(playlistsFromBE) < LIMIT,
    }));
  };

  // Detect When user scroll to bottom of table
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && !currentPage.isLast) {
      fetchMorePlaylists();
    }
  };

  return (
    <>
      <NavBar data="Unlimited Playlist" icon={Settings} currentRouteName="Unlimited Playlist" breadcrumbsPath={[{ name: 'Playlist' }]} />
      <div className="content" style={{ marginTop: 73 }}>
        <div style={{ marginBottom: 12, width: '100%' }}>
          <Grid container style={{ justifyContent: 'space-between' }}>
            <SearchBox onChange={(e) => setSearchInput(e)} />
            <Grid item>
              <Button
                isLoading={loading}
                onClick={() => {
                  history.push('/unlimited-new-playlist?plan=unlimited');
                }}
                className="round_btn"
              >
                Create New Playlist
              </Button>
            </Grid>
          </Grid>
        </div>

        <PlaylistTable initialLoading={isLoading} tableLoading={isFetchingMore} data={playlists} type="UNLIMITED" onScroll={handleScroll} />
      </div>
    </>
  );
};

export default UnlimitedPlaylist;

